import React, { useEffect } from "react";
import { setupPresence } from "../Components/firebase"; // same helper you already have

const CurrentUserContext = React.createContext({
  currentUser: null,
  setCurrentUser: () => {},
});

const CurrentUserProvider = ({ currentUser, setCurrentUser, children }) => {
  useEffect(() => {
    if (!currentUser?.id) return;

    let cleanup;

    const init = async () => {
      cleanup = await setupPresence(currentUser.id);
    };

    init();

    return () => {
      if (cleanup) cleanup();
    };
  }, [currentUser?.id]);

  return (
    <CurrentUserContext.Provider value={{ currentUser, setCurrentUser }}>
      {children}
    </CurrentUserContext.Provider>
  );
};

export { CurrentUserContext, CurrentUserProvider };
